// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2z50V","col":"Table_col__30Efn","fulfillmentStatus":"Table_fulfillmentStatus__1Aldm","emailCol":"Table_emailCol__18M9e"};